/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Permission_Filter_EmptyInputs */

const fr_permission_filter_empty = /** @type {(inputs: Permission_Filter_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune permission ne correspond à votre recherche.`)
};

/**

* @param {Permission_Filter_EmptyInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const permission_filter_empty = /** @type {((inputs?: Permission_Filter_EmptyInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Permission_Filter_EmptyInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_permission_filter_empty(inputs)
});